// extracted by mini-css-extract-plugin
module.exports = {"villasLaunchPageOuter":"style_villasLaunchPageOuter__vU6xO","villasLaunchPageBlock":"style_villasLaunchPageBlock__VsfC0","wildFloatingButton":"style_wildFloatingButton__JYPld"};